import { Store } from 'redux';

import { GlobalState } from 'ha/types/store';
import { PRICING_SLUG } from 'ha/constants/PricingPageSlug';

import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';

export const pricingPageRoute = (
  store: Store<GlobalState>,
  getComponents: (pageName: string) => void,
) => {
  const currentLanguage = getCurrentLanguageCode(store.getState());
  const pricingSlug = encodeURIComponent(PRICING_SLUG[currentLanguage]);

  return {
    path: `${pricingSlug}/:userType`,
    getComponents: getComponents('Pricing'),
  };
};
